import {
  COUNTRIES,
  CURRENCIES,
  DATE_PATTERNS,
  LANGUAGES,
  TIME_PATTERNS,
  TIMEZONES,
} from '@my/platform/options';
import type { SelectInputOption } from '@my/ui';

/**
 * The option lists the organisation panels share.
 *
 * <p>
 * One copy so the create form and the edit panel cannot offer different sets —
 * an organisation created with a currency the editor does not list would be
 * unfixable from this screen, which is exactly the trap the base currency is
 * already close to.
 * </p>
 */
export const COUNTRY_OPTIONS: SelectInputOption[] = COUNTRIES.map((c) => ({
  value: c.isoCode,
  label: `${c.flagEmoji} ${c.name}`,
}));

export const CURRENCY_OPTIONS: SelectInputOption[] = CURRENCIES.map((c) => ({
  value: c.isoCode,
  label: `${c.name} (${c.isoCode})`,
}));

export const TIMEZONE_OPTIONS: SelectInputOption[] = TIMEZONES.map((z) => ({
  value: z.iana,
  label: z.label,
}));

export const LANGUAGE_OPTIONS: SelectInputOption[] = LANGUAGES.map((l) => ({
  value: l.isoCode,
  label: `${l.name} (${l.nativeName})`,
}));

export const TIME_PATTERN_OPTIONS: SelectInputOption[] = TIME_PATTERNS.map((t) => ({
  value: t.pattern,
  label: t.label,
}));

export const DATE_PATTERN_OPTIONS: SelectInputOption[] = DATE_PATTERNS.map((d) => ({
  value: d.pattern,
  label: d.label,
}));

export function currencyLabel(isoCode: string | null | undefined): string {
  if (!isoCode) return '';
  const match = CURRENCIES.find((c) => c.isoCode === isoCode);
  return match ? `${match.name} (${match.isoCode})` : isoCode;
}
